<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "Agenda"
    }
  },
  data: () => ({
    expedienteLocalList: {},
    projetoList: {},
    consultorList: {}
  }),
  created() {
    this.expgetExpedienteLocalList();
    this.getProjetoList();
    this.getConsultorList();
  },
  methods: {
    expgetExpedienteLocalList() {
      api
        .get(`crud/ExpedienteLocal`, {
          params: {
            sortBy: "denominacao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.expedienteLocalList = response.data["data"]));
    },
    getProjetoList() {
      api
        .get(`crud/Projeto`, {
          params: {
            sortBy: "descricao",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.projetoList = response.data["data"]));
    },
    getConsultorList() {
      api
        .get(`crud/Consultor`, {
          params: {
            sortBy: "nome",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.consultorList = response.data["data"]));
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <b-form-group id="input-group-1" label="Projeto" label-for="projetoId">
        <b-form-select
          id="projetoId"
          v-model="item.projetoId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in projetoList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.descricao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="Local do Expediente"
        label-for="expedienteTipoId"
      >
        <b-form-select
          id="expedienteLocalId"
          v-model="item.expedienteLocalId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in expedienteLocalList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.denominacao }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-2"
        label="Consultor"
        label-for="consultorId"
      >
        <b-form-select
          id="consultorId"
          v-model="item.consultorId"
          :disabled="!this.editForm"
          required
        >
          <b-form-select-option disabled :value="undefined"
            >Selecione um item da lista</b-form-select-option
          >
          <b-form-select-option
            v-for="option in consultorList"
            :key="option.id"
            :value="option.id"
          >
            {{ option.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group id="input-group-1" label="Data" label-for="data">
        <b-form-datepicker
          id="data"
          v-model="item.data"
          :disabled="!this.editForm"
          required
          placeholder="Selecione uma data"
          :hide-header="true"
        ></b-form-datepicker>
      </b-form-group>

      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Horário de início"
          label-for="horaInicio"
          class="col-md-2"
        >
          <b-form-input
            id="horaInicio"
            v-model="item.horaInicio"
            type="text"
            v-mask="'##:##'"
            placeholder="00:00"
            :disabled="!this.editForm"
            required
          />
        </b-form-group>

        <b-form-group
          id="input-group-1"
          label="Horário de término"
          label-for="horaFim"
          class="col-md-2"
        >
          <b-form-input
            id="horaFim"
            v-model="item.horaFim"
            type="text"
            v-mask="'##:##'"
            placeholder="00:00"
            :disabled="!this.editForm"
            required
          />
        </b-form-group>
      </div>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
